module.exports = __webpack_public_path__ + "static/media/mode-22.18156247.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-22.svg
// module id = 995
// module chunks = 2